var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path6, _path7, _path8, _rect2, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneFreeTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 146,
    viewBox: "0 0 262 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 110C76.6995 110 57 90.3005 57 66C57 41.6995 76.6995 22 101 22C125.301 22 145 41.6995 145 66C145 90.3005 125.301 110 101 110Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109 146C84.6995 146 65 126.301 65 102C65 77.6995 84.6995 58 109 58C133.301 58 153 77.6995 153 102C153 126.301 133.301 146 109 146Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161 112C134.49 112 113 90.5097 113 64C113 37.4903 134.49 16 161 16C187.51 16 209 37.4903 209 64C209 90.5097 187.51 112 161 112Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152 146C125.49 146 104 124.51 104 98C104 71.4903 125.49 50 152 50C178.51 50 200 71.4903 200 98C200 124.51 178.51 146 152 146Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 88C105.699 88 86 68.3005 86 44C86 19.6995 105.699 0 130 0C154.301 0 174 19.6995 174 44C174 68.3005 154.301 88 130 88Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 262 53)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 52 134)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 58)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 59 7)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 200 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 233 135)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 22,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#EB5756"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167 47L109 105",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153 52.1716V46C153 44.8954 152.105 44 151 44H119C117.895 44 117 44.8954 117 46V86.5858C117 87.4767 118.077 87.9229 118.707 87.2929L152.414 53.5858C152.789 53.2107 153 52.702 153 52.1716Z",
    fill: "#24284E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117 97.8284V102C117 103.105 117.895 104 119 104H151C152.105 104 153 103.105 153 102V63.4142C153 62.5233 151.923 62.0771 151.293 62.7071L117.586 96.4142C117.211 96.7893 117 97.298 117 97.8284Z",
    fill: "#24284E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 3,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 141 47)",
    fill: "#EB5756"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 27L239 20.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 99.5L250 104",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.5L33.5 22.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 106L36.5 99.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFreeTime);
export default __webpack_public_path__ + "static/media/phone-free-time.a2703d04736cb9a23136ba22b0c4f70a.svg";
export { ForwardRef as ReactComponent };